<template>
  <footer class="page-footer">
    <div v-if="visibleLinks.length" class="reference-links">
      <div class="reference-links__heading">{{ text.referenceLinksHeading }}</div>
      <ul class="reference-links__list">
        <li v-for="link in visibleLinks" :key="link.urlKey">
          <a
            :href="text.urls[link.urlKey]"
            target="_blank"
            rel="noopener noreferrer"
            >{{ link.label }}</a
          >
          <small v-if="link.suffix" class="reference-links__note">{{
            link.suffix
          }}</small>
        </li>
      </ul>
    </div>
    <div class="copyright">{{ title }}</div>
  </footer>
</template>
<script>
import { WelcomeText } from "../js/PdfConstants.js";

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return { text: WelcomeText };
  },
  computed: {
    visibleLinks() {
      return this.text.referenceLinks.filter(
        (link) => this.text.urls[link.urlKey]
      );
    }
  }
};
</script>
<style lang="scss" scoped>
footer {
  background-color: $hpFooterBackground;
  width: 100%;
  text-align: center;
  color: $hpWhite;
  font-size: 14px;
  padding: 12px 16px;
}

.reference-links {
  margin-bottom: 10px;
}

.reference-links__heading {
  font-weight: $hpFontWeightMedium;
  margin-bottom: 6px;
}

.reference-links__list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px 24px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.reference-links__list a {
  color: $hpWhite;
  text-decoration: underline;
}

.reference-links__note {
  font-size: 0.8em;
}

.reference-links__list a:hover {
  color: $hpWhite;
  opacity: 0.8;
}

@media (max-width: 600px) {
  .reference-links {
    text-align: left;
  }

  .reference-links__list {
    flex-direction: column;
    justify-content: flex-start;
  }
}
</style>
